"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var state = {
  pageInit: false,
  // 页面是否初次打开
  loadingNum: 0 // 全局loading请求数量
};
var mutations = {
  SET_PAGEINIT: function SET_PAGEINIT(state, pageInit) {
    state.pageInit = pageInit;
  },
  SET_LOADINGNUM: function SET_LOADINGNUM(state, num) {
    state.loadingNum += num;
  }
};
var actions = {};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};